export { default } from './LoanCategoryTooltip'
